export default __webpack_public_path__ + "static/media/d.e169820e8c1426e8dd31e6299f4bc91e.mp3";